<template>
	<div id="preview" class="column col-lg-6 col-md-6 col-sm-12">
		<div class="panel">
			<div class="panel-header">
				<div class="panel-title"><b>Prévisualisation</b></div>
				<div class="panel-body">
					<div class="" style="padding: 44px 0px">
						<div style="text-align: left" id="code">
							<table
								cellpadding="0"
								cellspacing="0"
								border="0"
								style="
									background-color: #fff;
									border-width: 0px;
									border: 0px;
									margin: 0 0 0 0;
									padding: 12px;
									color: #6f6f6f;
									font-family: Arial, Helvetica, sans-serif;
									width: 100%;
									max-width: 450px;
								"
							>
								<tr>
									<td
										valign="middle"
										style="
											padding-top: 0;
											padding-bottom: 16px;
											padding-left: 0;
											padding-right: 0;
											vertical-align: middle;
										"
										colspan="2"
									>
										<span
											style="
												color: #6f6f6f !important;
												margin-bottom: 0;
												font-size: 16px;
												font-weight: 400;
											"
											>{{ firstname }}</span
										>{{ " " }}
										<span
											style="
												color: #6f6f6f !important;
												margin-bottom: 0;
												font-size: 16px;
												font-weight: 700;
												text-transform: uppercase;
											"
											>{{ name }}</span
										>
									</td>
								</tr>

								<tr>
									<td
										valign="middle"
										style="
											padding-top: 0;
											padding-bottom: 0px;
											padding-left: 0;
											padding-right: 10px;
											vertical-align: middle;
											border-right: 1px solid #6f6f6f;
										"
									>
										<p
											style="
												color: #6f6f6f !important;
												font-size: 12px;
												line-height: 1.2;
												font-weight: 400;
												margin: 0;
												padding-right: 16px;
											"
											v-if="usertitle"
											v-html="usertitle"
										></p>
									</td>

									<td
										valign="middle"
										style="
											padding-top: 0;
											padding-bottom: 0px;
											padding-left: 16px;
											padding-right: 0;
											border-top: 0;
											border-bottom: 0;
											border-left: 0;
											vertical-align: middle;
											text-align: left;
										"
									>
										<p
											style="
												font-size: 11px;
												text-transform: uppercase;
												line-height: 1;
												color: #6f6f6f;
												vertical-align: middle;
												margin: 0;
											"
										>
											Bertouil &amp; tartini<br />Experts immobiliers
											associés
										</p>
									</td>
								</tr>

								<tr style="margin: 0; padding: 0">
									<td
										style="
											height: 1px;
											margin: 0;
											padding: 0.2rem 0 0 0;
										"
										colspan="2"
									>
										&nbsp;
									</td>
								</tr>

								<tr>
									<td
										valign="middle"
										style="
											padding-top: 0;
											padding-bottom: 0;
											padding-left: 0;
											padding-right: 10px;
											vertical-align: middle;
											border-right: 1px solid #6f6f6f;
										"
									>
										<img
											alt=""
											src="https://rease.be/wp-content/uploads/2024/02/rease-logo@2x.png"
											width="133.34"
											height="45.71"
											style="vertical-align: middle"
										/>
									</td>

									<td
										valign="middle"
										style="padding-top: 0; padding-bottom: 0; padding-left: 16px; padding-right: 0; border-top: 0; border-bottom: 0: border-left: 0;
											vertical-align: middle; text-align: right;"
									>
										<table
											cellpadding="0"
											cellspacing="0"
											border="0"
											style="
												background-color: #fff;
												border-width: 0px;
												border: 0px;
												margin: 0 0 0 0;
												color: #6f6f6f;
												font-family: Arial, Helvetica, sans-serif;
												width: 100%;
												verical-align: middle;
											"
										>
											<tr>
												<td
													style="
														text-align: left;
														verical-align: middle;
													"
												>
													<p style="line-height: 1; margin: 0">
														<a
															v-if="usermail"
															v-html="usermail"
															style="
																color: #6f6f6f !important;
																font-size: 12px;
																text-decoration: none !important;
															"
															:href="'mailto:' + usermail"
														></a>

														<br />

														<a
															style="
																color: #6f6f6f !important;
																font-size: 12px;
																text-decoration: none !important;
															"
															href="https://www.rease.be"
															>www.rease.be</a
														>
														<br />
														<a
															v-if="userphone"
															:href="'tel:' + userphone"
															style="
																color: #6f6f6f !important;
																font-size: 12px;
																text-decoration: none !important;
															"
															>{{ userphone }}</a
														>
													</p>
												</td>
												<td
													class="text-align: right; verical-align: middle;"
												>
													<a
														v-if="userlinkedin"
														:href="userlinkedin"
														target="_blank"
													>
														<img
															alt=""
															src="https://rease.be/wp-content/uploads/2024/02/logo-linkedin@2x.png"
															width="24"
															height="24"
															style="vertical-align: middle"
														/>
													</a>
												</td>
											</tr>
										</table>
									</td>
								</tr>
							</table>
						</div>
					</div>
				</div>
				<div class="panel-footer">
					<form>
						<div class="form-group">
							<label class="form-label" for="input-code"
								>Code de la signature</label
							>
							<textarea
								class="form-input"
								id="input-code"
								v-html="code"
							></textarea>
						</div>
						<button
							type="button"
							class="btn btn-primary"
							v-on:click="saveCode"
							style="margin-right: 10px"
						>
							Copier le code
						</button>
						<a
							id="download_link"
							class="btn btn-primary"
							href="#"
							download="signature.txt"
							>Télécharger le code</a
						>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Preview",
	props: {
		arr: Array,
	},
	data: function () {
		return {
			name: "",
			firstname: "",
			usertitle: "",
			userphone: "",
			usermail: "",
			userlinkedin: "",
			code: "",
			textFile: null,
		};
	},
	watch: {
		arr: function () {
			this.name = this.arr[0];
			this.firstname = this.arr[1];
			this.usertitle = this.arr[2];
			this.userphone = this.arr[3];
			this.usermail = this.arr[4];
			this.userlinkedin = this.arr[5];
		},
	},
	updated: function () {
		this.setCode();
	},
	methods: {
		setCode: function () {
			this.code = document.getElementById("code").innerHTML;
			this.code = this.code.trim();
			var link = document.getElementById("download_link");
			link.href = this.downloadCode(this.code);
		},
		saveCode: function () {
			document.getElementById("input-code").select();
			document.execCommand("copy");
			alert("Vous pouvez coller votre code !");
			return false;
		},
		downloadCode: function (the_code) {
			var code_file = new Blob([the_code], { type: "text/plain" });
			if (this.textFile !== null) {
				window.URL.revokeObjectURL(this.textFile);
			}
			this.textFile = window.URL.createObjectURL(code_file);
			return this.textFile;
		},
	},
};
</script>
